import React from 'react';
import PropTypes from 'prop-types';
import ButtonsFooter from './ButtonsFooter';
import QuestionHeader from './QuestionHeader';


const QuestionContainer = ({
  title, onGoBack, saveQuestion, onHide, children,
}) => (
  <React.Fragment>
    <QuestionHeader title={title} onGoBack={onGoBack} />
    {children}
    <ButtonsFooter onConfirm={saveQuestion} onCancel={onHide} />
  </React.Fragment>
);


QuestionContainer.defaultProps = {
  title: '',
};

QuestionContainer.propTypes = {
  title: PropTypes.string,
  onGoBack: PropTypes.func.isRequired,
  saveQuestion: PropTypes.func.isRequired,
  onHide: PropTypes.func.isRequired,
  children: PropTypes.node.isRequired,
};

export default QuestionContainer;
